module["exports"] = {
  "descriptor": [
    "Ansvarig",
    "Senior",
    "Junior",
    "Företags",
    "Organisatorisk",
    "Intern",
    "Tillträdande",
    "Nationell",
    "Internationell",
    "Regional",
    "Global"
  ],
  "level": [
    "Verkställande",
    "Program",
    "Varumärke",
    "Säkerhet",
    "Forskning",
    "Marknadsföring",
    "Direktiv",
    "Implementation",
    "Integration",
    "Funktionalitet",
    "Taktik",
    "Marknader",
    "Division",
    "Grupp",
    "Optimering",
    "Infrastruktur",
    "Operativ",
    "Finansiell",
    "Kommunikation"
  ],
  "job": [
    "Direktör",
    "Ingenjör",
    "Handledare",
    "Koordinator",
    "Specialist",
    "Administratör",
    "Arkitekt",
    "Analytiker",
    "Designer",
    "Planerare",
    "Tekniker",
    "Utvecklare",
    "Konsult",
    "Representant",
    "Chef",
    "Producent",
    "Assistent"
  ]
};
